/* eslint-disable react/jsx-no-bind */
/* eslint-disable camelcase */
/*
Item: Form to xxx
Name: KeyFigure
Format: Frontend component, partial screen
*/

import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { SelectButton } from 'primereact/selectbutton';
import { Menubar } from 'primereact/menubar';
import { ProgressSpinner } from 'primereact/progressspinner';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Dialog } from 'primereact/dialog';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { OverlayPanel } from 'primereact/overlaypanel';
import { InputText } from 'primereact/inputtext';
import ExportTableDialog from '../components/dialogue/ExportTableDialog';
import { DropdownLabeled } from '../components/DropdownLabeled';
import Container from '../components/dragdrop/Container';
import ColContainer from '../components/dragdrop/ColContainer';
import HeadingsContainer from '../components/dragdrop/HeadingsContainer';
import MessageService from '../service/MessageService';
import JsonHelper, {
  saveVariables,
  KeyFigureNames, KeyStatusNames, KeyFigureNumbers, maximizeTable, getEntryNum,
} from '../utils/statisticsUtils';
import { MultiLanguage } from '../utils/MultiLanguage';
import TreeSerializer from '../utils/TreeSerializer';
import { DestatisTableRenderer2 } from '../pocComponents/TableRenderers';
import templateTable from '../service/data/TemplateTable.json';

function convertToLocal(convertTime) {
  let d = '';
  if (convertTime) {
    // correct time to local
    const year = convertTime.substring(6, 10);
    const month = convertTime.substring(3, 5);
    const day = convertTime.substring(0, 2);
    const time = convertTime.substring(11, 19);
    const dateString = `${month} ${day} ${year} ${time} GMT`;
    const curr = Date.parse(dateString);
    d = new Date(curr);
  }
  return d;
}

function baseTemplate(rowData) {
  let retText;
  if (rowData.basisCube) {
    retText = (<i className="pi pi-md-check" />);
  } else {
    retText = '';
  }

  return (
    <span>
      {retText}
    </span>
  );
}

export default class KeyFigure extends Component {
  constructor() {
    super();
    this.state = {
      // state for wait spinner dialog
      visibleWait: false,
      allNodes: {},
      tableRendered: [],
      data_html: '',
      layoutStage: 0,
      filter: [],
      filtered: 'default',
      filter_graph: [],
      precondition_graph: [],
      pureFilter_graph: [],
      headings: [],
      headings_graph: [],
      zeilen: [],
      zeilen_graph: [],
      spalte1: [],
      spalte1_graph: [],
      layout: [],
      arrFiltersById: {},
      globalFilter: [],
      colHelperArray: [],
      rowHelperArray: [],
      auspraegungenMap: {},
      arrRuleById: {},
      arrRulesById: {},
      arrSortingById: {},
      arrDisplayById: {},
      arrBMMById: {},
      arrDirectionById: {},
      arrSumUpById: {},
      arrCalcUpById: {},
      selectedSum: [],
      selectedId: '',
      checked1: true,
      checked2: true,
      table_html: {},
      hideRetrievalButton: false,
      overlayFilter: ['', '', '', '', '', ''],
      overlayHasFilter: [false, false, false, false, false, false],
      overlayId: 0,
      overlayFilteredList: [undefined, undefined, undefined, undefined, undefined, undefined],
    };
    this.multiLanguage = new MultiLanguage();
    this.messageService = new MessageService();
    this.actionTemplate = this.actionTemplate.bind(this);
    this.loadNode = this.loadNode.bind(this);
    this.sorting = [
      { label: 'Fachschlüssel', value: 'FS' },
      { label: 'Klarname', value: 'KN' },
      { label: 'Klassifikationsschlüssel', value: 'KS' },
      { label: 'Verbundschlüssel', value: 'VS' }
    ];
    this.display = [
      { label: 'Fachschlüssel', value: 'FS' },
      { label: 'Klarname', value: 'KN' },
      { label: 'Fachschlüssel und Klarname', value: 'FSKN' },
      { label: 'Klassifikationsschlüssel', value: 'KS' },
      { label: 'Klassifikationsschlüssel und Klarname', value: 'KSKN' },
      { label: 'Fachschlüssel und Klassifikationsschlüssel', value: 'FSKS' },
      { label: 'Verbundschlüssel', value: 'VS' },
      { label: 'Verbundschlüssel und Klarname', value: 'VSKN' },
      { label: 'Fachschlüssel und Verbundschlüssel', value: 'FSVS' },
    ];
    this.displayRulesEmpty = [
      { label: 'keine Regel', value: '' },
    ];
    this.test = [];
  }

  componentDidMount = async () => {
    const name = KeyFigureNumbers[window.location.href.split('&')[1]];
    const selectedStatistics = [{ name }];
    this.setState({ visibleWait: true });
    const intersection = await this.returnIntersection(selectedStatistics);
    const type = 'structure';
    const right = 'ALL';
    const objectNumber = '108';
    const objectTyp = 'STRUCTURE';
    const prefix = '1';
    const linksArray = [
      {
        '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
        type: 'STATISTIC',
        name,
        reference: null,
        id: -1,
        shortDescription: '',
        idList: [],
      },
    ];
    const children = await this.getDirectory(type, right, objectNumber, objectTyp,
      prefix, undefined, undefined, linksArray);
    this.setState({ visibleWait: false, intersection });
  }

  async renderTable() {
    const zeilen_graph = this.mergeGraphsRows();
    const spalte1_graph = this.mergeGraphs();
    const {
      headings_graph, pureFilter_graph,
      precondition_graph,
    } = this.state;
    const graphen = {
      spalte1_graph: JsonHelper.deepCopy(spalte1_graph),
      realHeadings_graph: JsonHelper.deepCopy(headings_graph),
      zeilen_graph: JsonHelper.deepCopy(zeilen_graph),
      pureFilter_graph: JsonHelper.deepCopy(pureFilter_graph),
      precondition_graph: JsonHelper.deepCopy(precondition_graph),
    };
    let tree = TreeSerializer.build_directory_dto(graphen);
    let tree2 = TreeSerializer.build_directory_dto(graphen);
    console.log('LOADEDT#029', tree2);
    this.setState({ visibleWait: true });
    const valueEmptyLines = false;
    const { objectTable, auspraegungenMap } = this.state;
    const test = [];
    // console.log('renderTable#0', objectTable);
    // Zeitscheiben aus objectTable possibleTimes in FE übertragen
    let { possibleTimes } = objectTable.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap;
    // console.log('renderTable#1', possibleTimes);
    // Format bauen
    if (possibleTimes) possibleTimes = this.createTimeArray(possibleTimes);
    console.log('448##8', possibleTimes);
    // Variable speichern
    this.setState({ possibleTimes });
    // in Zeit-MM als Auswahl anbieten
    // bei Auswahl tree.structureAxis ändern:
    const { structureAxis } = objectTable.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0];
    // über alle Werte in tree.structureAxis;
    console.log('TREE#', tree.structureAxis);
    let count = 0;
    for (let ii = 0; ii < tree.structureAxis.length; ii += 1) {
      if (tree.structureAxis[ii].children.length > 0) { // // wenn children.length > 0
        const { position } = tree.structureAxis[ii];
        console.log('LOADEDT#030', position);
        for (let kk = 0; kk < structureAxis.length; kk += 1) {
          if (structureAxis[kk].position === position) { // suche in objectTable...
            structureAxis[kk] = tree.structureAxis[ii]; // tausche Wert
          }
        }
      }
    }
    console.log('NODENAME#8', structureAxis);
    tree.structureAxis = structureAxis;
    tree.footnote = objectTable.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].footnote;
    let filter = [];
    let headings = [];
    let zeilen = [];
    let spalte1 = [];
    // init + retrieval
    // console.log('SORT#', spalte1_graph);
    // const zeilen_graph = this.mergeGraphsRows();
    // clean tree from unwanted entries:
    const tree1 = this.removeUnwanted(tree);
    // SUBHEADING to SUBTITLE
    const returnMessage = await this.messageService.postValueRetrievalKeys('valueretrieval', tree1, undefined, false); // valueretrieval/retrieval Message 1 i.e. StructureDTO
    let hasSecrets = true;
    if (returnMessage[1] === 'error') {
      this.growl.show({
        life: 12000,
        severity: returnMessage[1],
        summary: 'Fehler',
        detail: returnMessage[0],
      });
    } else {
      const { showSecretValues } = returnMessage[0].contents['genesis.container.content.GenesisTMContent'].parameter.hashMap;
      hasSecrets = showSecretValues === ['true'];
      for (let i = 0; i < tree.structureAxis.length; i += 1) {
        const { position, children } = tree.structureAxis[i];
        console.log('possibleTimes#child#' + i, children, children.length);

        console.log('448#62', i, auspraegungenMap);
        for (let j = 0; j < children.length; j += 1) {
          const entry = children[j];
          if (true || entry.type === 'VARIABLE') {
            console.log('448#63', entry.name);
            test[count] = {
              auspraegungen: '',
              code: entry.name,
              inhalt: this.multiLanguage.returnInLanguage(entry, 'de'),
              links: '',
              typ: '',
            };
            count += 1;
          }
        }
        console.log('448##1', test);
        for (let j = 0; j < children.length; j += 1) {
          const child = children[j];
          console.log('possibleTimes#child#' + i + '.' + j, child);
          if (child.variableType === 'TIME_IDENTIFYING') {
            auspraegungenMap[child.name] = possibleTimes;
          }
          console.log('448#62#child6', auspraegungenMap, position)
          child.uniqueId = `id${position}${j}`; // set ID for connection btw. card and Statistics.jsx; was '';
          child.activeRule = false;
          child.activeFilter = false;
          child.showRules = false;
          child.text = `${this.multiLanguage.returnInLanguage(child, 'de')} [${child.name}]`;
          child.title = `${this.multiLanguage.returnInLanguage(child, 'de')} [${child.name}]`;
          child.code = child.name;
          child.expanded = true;
          child.inhalt = this.multiLanguage.returnInLanguage(child, 'de');
          switch (position) {
            case 'TABLE_FILTER':
              filter[j] = child;
              break;
            case 'COLUMN_STRUCTURE':
              spalte1[j] = child;
              break;
            case 'ROW_STRUCTURE':
              zeilen[j] = child;
              break;
            case 'SUBTITLE':
              headings[j] = child;
              console.log('possibleTimes#child7st', child);
              break;
            case 'SUBHEADING':
              headings[j] = child;
              console.log('possibleTimes#child7sh', child);
              break;
            case 'PRECONDITION':
              // ???[j] = child;
              break;
            default:
            // nothing
          }
          console.log('possibleTimes#child#' + i + '.' + j, child);
          // console.log('RULESMAP0', child.variableType, child.name);
          if (child.variableType !== 'VALUE' && child.variableType !== 'UNDEF') {
            this.getValueStructureDirectory(child.name);
            // console.log('RULESMAPafter', child.variableType);
          }
        }
      }
      // const tree2 = TreeSerializer.build_directory_dto(tree);
      const deepCopyReturnMessage = JsonHelper.deepCopy(returnMessage[0]);
      if (valueEmptyLines) {
        deepCopyReturnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.renderer[0].blankcolumns = valueEmptyLines;
        deepCopyReturnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.renderer[0].blankrows = valueEmptyLines;
        deepCopyReturnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.exportsettings.resulttablesettings.ignorBlankRows = valueEmptyLines;
      }
      const elementsData = await this.messageService.postValueRetrievalHtml('valueretrieval', deepCopyReturnMessage); // valueretrieval/htmltable Message 2 i.e. request for GOM container a HTML
      if (elementsData[1] === 'error') {
        this.growl.show({
          life: 12000,
          severity: elementsData[1],
          summary: 'Fehler',
          detail: elementsData[0],
        });
      } else {
        const htmlTable = this.returnTable(elementsData); // extracted <table> from elementsDate
        const savedStructureDTO = returnMessage[1];
        console.log('448#64', auspraegungenMap, test);
        console.log('448#64.1', auspraegungenMap, filter);
        this.setState({
          data_html: { data_html: htmlTable },
          filter,
          val_graph: filter,
          zeilen,
          zeilen_graph: zeilen,
          spalte1,
          col_graph: spalte1,
          headings,
          title_graph: headings,
          hasSecrets,
          valueStartStructure: deepCopyReturnMessage,
          test,
        });
      }
    }
    this.setState({ visibleWait: false });
  }

  async exportTable(option, name) {
    const { valueStartStructure } = this.state;
    // valueStartStructure.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.path = ['c://Lokaler Datenbereich//'];
    valueStartStructure.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.filename = [name];
    valueStartStructure.contents['genesis.container.content.GenesisTMContent'].transfermodel.exportsettings.resulttablesettings.chosenFormat = option;
    const tmp = JsonHelper.deepCopy(valueStartStructure);
    const returnMessage = await this.messageService.postTableExport('valueretrieval', tmp);
    if (returnMessage[1] === 'error') {
      this.growl.show({
        life: 12000, severity: returnMessage[1], summary: 'Fehler', detail: returnMessage[0][0].message,
      });
    } else {
      const returnMessageD = await this.messageService.postTableExportDownload('valueretrieval', tmp);
      this.growl.show({ severity: 'info', summary: 'Tabelle Exportieren', detail: 'Export erfolgreich, Download startet in Kürze.' });
      const element = document.createElement('a');
      let fileType = '';
      let mimeType = '';
      let data = [returnMessageD[1]];
      const BOM = '\ufeff'; // for charset encoding, there has to be a better way
      if (option === 'CSV_TABLE') {
        fileType = '.csv';
        mimeType = 'text/csv;charset=utf-8';
        data = [BOM, returnMessageD[1]];
      } else if (option === 'XLSX') {
        fileType = '.xlsx';
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      } else if (option === 'FLATFILECSV_TABLE') {
        fileType = '.csv';
        mimeType = 'flatfile/csv;charset=utf-8'; // TODO 1889
        data = [BOM, returnMessageD[1]];
      } else {
        fileType = '.csv';
        mimeType = 'text/csv;charset=utf-8';
      }
      const file = new Blob(data, { type: mimeType });
      element.href = URL.createObjectURL(file);
      element.download = name + fileType;
      document.body.appendChild(element); // Required for this to work in FireFox
      element.click();
      this.onHideExportTable();
    }
  }

  showExportTable() {
    this.setState({ exportTableVisible: true });
  }

  onHideExportTable() {
    this.setState({ exportTableVisible: false });
  }

  setValues(e) {
    // console.log('showlist#4.0 setValue', e.value);
    let arr = e.value;
    if (arr) {
      if (arr.value != null) {
        if (arr.constructor !== Array) {
          arr = [e.value];
        }
      }
      const { selectedId, arrFiltersById } = this.state;
      // console.log('showlist#4', selectedId, arrFiltersById);
      // console.log('showlist#5', arr);
      arrFiltersById[selectedId] = arr;
      // console.log('showlist#6', arrFiltersById);
      this.setState({
        arrFiltersById,
        filtered: e.value,
      });
    }
  }

  async getValueStructureDirectory(merkmaleCode) {
    const type = 'valueassociation';
    const ttype = 'VARIABLE';
    const objtype = 'ASSOCIATIONVALUETOCLASSIFYINGVARIABLE';
    const { auspraegungenMap, intersection } = this.state;
    let tmp;
    // time slice intersection:
    const elementsData = await this.messageService.postRecordStructureDirectory(
      merkmaleCode, false, type, ttype, objtype,
    );
    console.log('448#00.1', merkmaleCode, false, type, ttype, objtype);
    if (elementsData[1] !== 'error') {
      // map smaller
      tmp = elementsData.map((entry) => ({
        name: entry.name,
        id: entry.id,
        classificationKey: entry.classificationKey,
        code: entry.name,
        inhalt: this.multiLanguage.returnInLanguage(entry, 'de'),
        links: '',
        merkmale: entry.variableCount,
      }));
    } else {
      // console.log('card. error', elementsData);
    }
    console.log('448#00.2', tmp);
    if (tmp) {
      if (tmp !== '') auspraegungenMap[merkmaleCode] = tmp.sort((a, b) => ((a.id > b.id) ? 1 : -1));
    }
    this.setState({ auspraegungenMap });
  }

  async getDirectory(type, right, objectNumber, objectTyp,
    prefix, typeString, onlyTable, linksArray) {
    // in JSON darf nur NAME für validSearchCriteria und validSortCriteria stehen.
    const elementsData = await this.messageService.postVariableDirectory('directory', type, right, objectNumber, objectTyp,
      typeString, onlyTable, linksArray);
    const ch = []; // children
    if (elementsData[1]) {
      this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: elementsData[0] });
    } else {
      const entries = elementsData.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
      // console.log('COUNTii#2');
      for (let ii = 0; ii < entries.length; ii += 1) {
        const dStart = convertToLocal(entries[ii].modifiedTime);
        const modifiedTime = dStart.toLocaleDateString('de-DE', { month: '2-digit', day: '2-digit', year: 'numeric' });
        ch[ii] = {};
        ch[ii].statistics = entries[ii].statistics;
        ch[ii].statisticID = entries[ii].statisticID;
        ch[ii].id = entries[ii].id;
        ch[ii].basisCube = entries[ii].basisCube;
        ch[ii].status = KeyStatusNames[entries[ii].status];
        ch[ii].name = entries[ii].name;
        ch[ii].caption = this.multiLanguage.returnLanguage(entries[ii].caption, 'de');
        // ch[ii].time = entries[ii].timeSlices[0].name;
        ch[ii].modifiedTime = modifiedTime;
      }
    }
    this.setState({ allNodes: ch });
  }

  renderColContainers() {
  }

  renderRowContainers() {
  }

  updateView() {
    // const rulesMap = JsonHelper.deepCopy(this.state.rulesMap);
    const auspraegungenMap = JsonHelper.deepCopy(this.state.auspraegungenMap);
    templateTable.val_graph = JsonHelper.deepCopy(this.state.filter_graph);
    // console.log('#DEBUG#', this.state.filter_graph)
    // templateTable.filter_graph = JsonHelper.deepCopy(this.state.filter_graph);
    templateTable.row_graph = this.mergeGraphsRows();
    templateTable.col_graph = this.mergeGraphs();
    templateTable.title_graph = JsonHelper.deepCopy(this.state.headings_graph);
    // templateTable.merkmale = JsonHelper.deepCopy(this.state.merkmale);
    // templateTable.rulesMap = rulesMap; // später
    templateTable.auspraegungenMap = auspraegungenMap;
    templateTable.arrDisplayById = JsonHelper.deepCopy(this.state.arrDisplayById);
    templateTable.arrBMMById = JsonHelper.deepCopy(this.state.arrBMMById);
    templateTable.arrSumUpById = JsonHelper.deepCopy(this.state.arrSumUpById);
    templateTable.arrCalcUpById = JsonHelper.deepCopy(this.state.arrCalcUpById);
    this.setState({ tableRendered: templateTable }, () => { console.log('callback:', this.state.tableRendered); });
  }

  doNesting = (list) => {
    // doNesting(list) {
    const nested_list = [];
    for (let i = list.length; i > 0; i -= 1) {
      if (i === list.length) {
        // nested_list[0] = { ...list[i - 1] };
        nested_list[0] = JsonHelper.deepCopy(list[i - 1]);
      } else {
        // let parent = { ...list[i - 1] };
        const parent = JsonHelper.deepCopy(list[i - 1]);
        // let child = { ...nested_list[0] };
        const child = JsonHelper.deepCopy(nested_list[0]);
        parent.children[0] = child;
        // console.log('PARENT: ', parent);
        nested_list[0] = parent;
      }
    }
    return nested_list;
  }

  showOverlay(e, sel, selectedId, type, containerName, instantReturn) {
    // Overlay für Äusprägungen anzeigen und vorbereiten für Eingabe
    // code, uniqueId, type
    if (instantReturn) return; // do not show
    const { arrFiltersById } = this.state;
    let canSumUp = true;
    this.setState({ hideRetrievalButton: true });
    let selectionMode = 'multiple';
    // 'TIME_IDENTIFYING' can use 'Zusammen'
    if (type === 'VARIABLE') type = card.output[0].reference.type;
    if (type === 'TIME_CLASSIFYING' || type === 'VALUE' || type === 'TIME_IDENTIFYING') {
      selectionMode = 'single';
      canSumUp = false;
    }
    const isTimeIdentifying = (type === 'TIME_IDENTIFYING');
    const isTimeClassifying = (type === 'TIME_CLASSIFYING');
    const isValue = (type === 'VALUE');
    if (containerName !== 'filter') {
      selectionMode = 'multiple';
    }
    if (containerName === 'filter') { canSumUp = false; }
    if (type === 'VALUE') { selectionMode = 'none'; }
    if (selectionMode === 'multiple') {
      const onlySelectedFilter = arrFiltersById[selectedId];
      if (onlySelectedFilter) {
        if (onlySelectedFilter.constructor !== Array) {
          const arrOnlySelectedFilter = [onlySelectedFilter];
          arrFiltersById[selectedId] = arrOnlySelectedFilter;
          this.setState({ arrFiltersById });
        }
      }
    }
    let showRuleSelection = 'true';
    if (containerName === 'headings' || containerName === 'filter' || type === 'VALUE') {
      showRuleSelection = false;
    }
    this.setState({
      // itemInListType: type,
      itemInList: sel,
      globalFilter: '',
      showRuleSelection,
      selectedId,
      selectionMode,
      selectedContainer: containerName,
      canSumUp,
      isTimeIdentifying,
      isTimeClassifying,
      isValue,
    });
    this.op.toggle(e);
  }

  hideOverlay(e) {
    // Overlay für Äusprägungen ausblenden
    this.op.hide(e);
  }

  mergeGraphs() {
    const mergedArray = [...JsonHelper.deepCopy(this.state.spalte1_graph)];
    console.log('MERGE#1', mergedArray);
    const helperArray = this.state.colHelperArray;
    helperArray.sort(this.sortFunction);
    this.state.colHelperArray.forEach((container) => {
      if (this.state[container].length > 0) {
        mergedArray.push(...JsonHelper.deepCopy(this.state[`${container}_graph`]));
      }
    });
    console.log('MERGE#2', mergedArray);
    return mergedArray;
  }

  mergeGraphsRows() {
    const mergedArray = [...JsonHelper.deepCopy(this.state.zeilen_graph)];
    const helperArray = this.state.rowHelperArray;
    helperArray.sort(this.sortFunction);
    this.state.rowHelperArray.forEach((container) => {
      if (this.state[container].length > 0) {
        mergedArray.push(...JsonHelper.deepCopy(this.state[`${container}_graph`]));
      }
    });
    return mergedArray;
  }

  removeUnwanted(input) {
    // console.log('objectTable#3.0', input);
    const tree = JsonHelper.deepCopy(input);
    // hole structureAxis
    const { structureAxis } = tree;
    // console.log('objectTable#3.1', structureAxis);
    const st = JsonHelper.deepCopy(structureAxis);
    // über alle im Array
    for (let i = 0; i < st.length; i += 1) {
      // über alle Children
      // console.log('objectTable#3.2', i, st[i]);
      for (let j = 0; j < st[i].children.length; j += 1) {
        // console.log('objectTable#3.3-', j, st[i].children[j]);
        if (st[i].children[j]) {
          let node = st[i].children[j];
          if (node.uniqueId) {
            delete node.uniqueId;
            delete node.activeFilter;
            delete node.activeRule;
            delete node.showRules;
            delete node.text;
            delete node.title;
            delete node.code;
            delete node.expanded;
            delete node.inhalt;
            delete node.display;
            delete node.filter; // darf man das hier schon?
          }
          st[i].children[j] = node;
        }
      }
    }
    tree.structureAxis = st;
    return tree;
  }

  createTimeArray(possibleTimes) {
    const ret = [];
    for (let i = 0; i < possibleTimes.length; i += 1) {
      ret[i] = {
        classificationKey: undefined,
        code: possibleTimes[i],
        id: i,
        inhalt: possibleTimes[i],
        links: '',
        merkmale: 0,
        name: possibleTimes[i],
      };
    }
    return ret;
  }

  async loadNode(node) { // param currentNode
    console.log('NODE#', node);
    const arrRefItem = [];
    const arrNewItem = [];
    const { group } = this.state;
    // const typ = 'structure';
    const { id } = node;
    const objectNumber = '108';
    const type = 'structure';
    // const nameState = '';
    this.setState({ visibleWait: true });
    try {
      // console.log('NODE#pre', id, objectNumber, type);
      const elementsData = await this.messageService.postRecordStructureProperties(
        id, objectNumber, type, false,
      );
      // console.log('NODE#1', elementsData);
      if (elementsData[0]) {
        this.growl.show({ severity: elementsData[1], summary: 'Hinweis', detail: elementsData[0] });
        // success = false;
      } else {
        let objectTable = elementsData;
        // success = true;
      }
      this.setState({
        layoutStage: 1,
        objectTable,
      });
      await this.renderTable();
      const { spalte1, filter, zeilen, headings } = this.state;
      let { spalte1_graph, filter_graph, zeilen_graph, headings_graph } = this.state;
      if (spalte1_graph.length === 0) spalte1_graph = spalte1;
      if (zeilen_graph.length === 0) zeilen_graph = zeilen;
      if (filter_graph.length === 0) filter_graph = filter;
      if (headings_graph.length === 0) headings_graph = headings;
    } catch (err) {
      console.log('Error in loadNode: ', err);
    } finally {
      this.setState({
        spalte1_graph,
        filter_graph,
        zeilen_graph,
        headings_graph,
        visibleWait: false,
      });
    }
    // return success;
    const tableData1 = [];
    for (let i = 0; i < saveVariables.length; i += 1) {
      tableData1[saveVariables[i]] = this.state[saveVariables[i]];
    }
    // console.log('VARIABLES#', tableData1);
    console.log('NODE#1', this.state);
  }

  setSumUp(e) {
    const { selectedId, arrSumUpById } = this.state;
    const { value } = e;
    console.log('INSGESAMT#4', value, value.indexOf('o'));
    if (value.indexOf('o') > -1) {
      if (value.indexOf('i') === -1) {
        value[value.length] = 'i';
      }
    }
    arrSumUpById[selectedId] = value;
    this.setState({
      arrSumUpById,
      sumUp: e.value,
    });
  }

  actionTemplate(node) {
    return (
      <div>
        <Button
          id="open"
          title="Öffnen"
          type="button"
          icon="pi-md-chevron-right"
          className="p-button-success"
          // onClick={() => this.props.history.push({ pathname: `./evaluation/statistics` })}
          onClick={() => this.loadNode(node)}
        />
      </div>
    );
  }

  goBack() {
    this.setState({
      layoutStage: 0,
      // reset:
      auspraegungenMap: {},
      arrRulesById: {},
      arrFiltersById: {},
      arrSumUpById: {},
      arrCalcUpById: {},
      arrDisplayById: {},
      arrBMMById: {},
      arrNameById: {},
      filter: [],
      filter_graph: [],
      headings: [],
      headings_graph: [],
      merkmal1: [],
      pureFilter_graph: [],
      precondition_graph: [],
      selectedId: '',
      spalte1: [],
      spalte1_graph: [],
      tableRendered: [],
      zeilen: [],
      zeile2: [],
      zeile3: [],
      zeile4: [],
      zeile5: [],
      zeilen_graph: [],
      zeilen1_graph: [],
      zeilen2_graph: [],
      zeilen3_graph: [],
      zeilen4_graph: [],
      zeilen5_graph: [],
    });
  }

  makeNestedList(targetContainer, targetList = []) {
    const stateOfTargetContainer = this.state[targetContainer];
    const deepCopy_targetContainer = JsonHelper.deepCopy(stateOfTargetContainer);
    const deepCopy_targetList = JsonHelper.deepCopy(targetList);
    const list = deepCopy_targetList.length > 0
      ? deepCopy_targetList.slice()
      : deepCopy_targetContainer.slice();
    if (targetContainer === 'filter') {
      const listFilter = [];
      const listPrecondition = [];
      for (let i = 0; i <= list.length - 1; i += 1) {
        if (!list[i].filter) {
          // no filter selected yet
          listFilter.push(list[i]);
        } else if (list[i].filter.length === 1) {
          listFilter.push(list[i]);
        } else {
          listPrecondition.push(list[i]);
        }
      }
      let nestedFilter = [];
      let nestedPrecondition = [];
      if (listFilter.length > 0) {
        nestedFilter = this.doNesting(listFilter);
      }
      if (listPrecondition.length > 0) {
        nestedPrecondition = this.doNesting(listPrecondition);
      }
      this.setState({ pureFilter_graph: nestedFilter }, () => { console.log('pureFilter_graph: ', this.state.pureFilter_graph); });
      this.setState({ precondition_graph: nestedPrecondition }, () => { console.log('precondition_graph: ', this.state.precondition_graph); });
    }
    const nestedList = this.doNesting(list);
    this.setState({ [`${targetContainer}_graph`]: nestedList }, () => { console.log(`${targetContainer}_graph: `, this.state[`${targetContainer}_graph`]); });
  }

  returnTable(ret) {
    let returnValue;
    if (ret[1]) {
      this.growl.show({
        life: 12000, severity: ret[1], summary: 'Fehler', detail: ret[0],
      });
      // return null
    } else {
      const str = ret.data.contents['genesis.container.content.GenesisTMContent'].transfermodel;
      const startPosition = str.indexOf('<body>');
      // eslint-disable-next-line
      const endPosition = str.indexOf("<\/body>");
      const table = str.substring(startPosition, endPosition + 7);
      returnValue = (table);
    }
    return returnValue;
  }

  removeCard(index, targetContainer) {
    // nothing
  }

  async returnIntersection(statisticNumbers) {
    // für die Studentenstatistik kann es bis zu 2 Zeitscheiben je Jahr geben
    let intersection = {};
    const selection = sessionStorage.getItem('evaluationRegional');
    const region = getEntryNum[sessionStorage.getItem('group').split(' ')[1]];
    return [];
  }

  // called with every property and its value recursively
  traverse(o, uniqueId, preparedFilter) {
    for (const i in o) {
      if ({}.hasOwnProperty.call(o, i)) {
        if (!!o[i] && typeof (o[i]) === 'object') {
          if (typeof (o[i]) === 'object') {
            if (o[i].uniqueId) {
              if (o[i].uniqueId === uniqueId) {
                o[i].filter = preparedFilter;
                o[i].activeFilter = true;
                return o;
              }
            }
          }
          this.traverse(o[i], uniqueId, preparedFilter);
        }
      }
    }
  }

  async setValuesOnHide() {
    const shortDescription = {
      '@type': 'MehrsprachigerText',
      langText: [
        {
          '@type': 'Text',
          sprachKennzeichen: 'de',
          text: 'text',
          approved: true,
          format: 'text_plain',
        },
        {
          '@type': 'Text',
          sprachKennzeichen: 'en',
          text: null,
          approved: false,
          format: 'text_plain',
        },
      ],
    };
    const {
      selectedContainer, direction, display, sumUp, sorting, selectedId, displayRules,
      arrCalcUpById, arrBMMById, arrNameById, calcModeOn,
    } = this.state;
    let { countFkt } = this.state;
    const uniqueId = selectedId;
    let { filtered } = this.state;
    if (filtered !== this.state.arrFiltersById[uniqueId]) {
      filtered = this.state.arrFiltersById[uniqueId];
    }
    if (filtered || display || sumUp || sorting || direction || displayRules || calcModeOn) {
      console.log('INIF#')
      if (filtered) {
        if (filtered.constructor.name !== 'Array') filtered = [filtered]; // selection from radio buttons cast to an array
      } else {
        filtered = 'default';
      }
      const obj = this.state[selectedContainer];
      const strSel = JSON.stringify(this.state[selectedContainer]);
      if (filtered && (filtered !== 'default')) {
        console.log('FILTER#00', filtered);
        if (strSel.indexOf(uniqueId) > -1) {
          // console.log('FILTER#1', filtered, filtered.constructor.name);
          const preparedFilter = filtered.map((entry) => entry.name);
          this.traverse(obj, uniqueId, preparedFilter); // traverse over each element in the array
        }
      }
      // console.log('FILTER#2', obj);
      let entry;
      if (calcModeOn) { // s. disabled
        const obj = this.state[selectedContainer];
        entry = obj.find((o) => o.uniqueId === uniqueId);
        if (arrBMMById[selectedId] === undefined && arrCalcUpById[selectedId] === 'am') {
          this.growl.show({
            life: 5000,
            severity: 'warn',
            summary: 'Hinweis',
            detail: 'Sie haben kein Bezugsmerkmal zur Berechnung des Arithmetischen Mittels gewählt. Die Option wurde für Sie automatisch deaktiviert.',
          });
          arrNameById[selectedId] = undefined;
          this.setState({
            calcModeOn: false,
            arrCalcUpById: {},
            arrNameById,
          });
          // console.log('NAME#ENTRY9', this.state.arrNameById);
        } else if (arrBMMById[selectedId] === undefined && arrCalcUpById[selectedId] === 'm') {
          this.growl.show({
            life: 5000,
            severity: 'warn',
            summary: 'Hinweis',
            detail: 'Sie haben kein Bezugsmerkmal zur Berechnung des Medians gewählt. Die Option wurde für Sie automatisch deaktiviert.',
          });
          arrNameById[selectedId] = undefined;
          this.setState({
            calcModeOn: false,
            arrCalcUpById: {},
            arrNameById,
          });
          // console.log('NAME#ENTRY9', this.state.arrNameById);
        } else {
          // BMM#
          if (arrCalcUpById[selectedId] === 'm') { // MEDIAN
            const ret = await this.messageService.getMedianobject();
            ret.data.variable = arrBMMById[selectedId];
            entry.output[0].reference = ret.data;
            entry.output[0].name = ret.data.name;
            entry.output[0].reference.decimals = 1;
            entry.output[0].type = 'FUNCTION';
            entry.output[0].visible = true;
            if (arrNameById[selectedId] && arrNameById[selectedId] !== '') {
              shortDescription.langText[0].text = arrNameById[selectedId];
              entry.output[0].reference.shortDescription = shortDescription;
            }
            // console.log('NAME#ENTRY0', entry.output[0]);
            // console.log('NAME#ENTRY1', arrNameById);
          }
          if (arrCalcUpById[selectedId] === 'am') { // AVERAGE
            const ret = await this.messageService.getAverageobject();
            ret.data.variable = arrBMMById[selectedId];
            entry.output[0].reference = ret.data;
            entry.output[0].name = ret.data.name;
            entry.output[0].reference.decimals = 1;
            entry.output[0].type = 'FUNCTION';
            entry.output[0].visible = true;
            if (arrNameById[selectedId] && arrNameById[selectedId] !== '') {
              shortDescription.langText[0].text = arrNameById[selectedId];
              entry.output[0].reference.shortDescription = shortDescription;
            }
            // console.log('NAME#ENTRY', entry.output[0]);
          }
          // console.log('BMM#', ret);
          countFkt += 1;
          this.setState({
            countFkt,
          });
        }
      }
      if (displayRules) {
        // ADBHSSTAT-1715 BUG HERE
        const obj = this.state[selectedContainer];
        // console.log('GRAPH#2', displayRules);
        entry = obj.find((o) => o.uniqueId === uniqueId);
        entry.activeRule = true;
        entry.ruleName = displayRules.name;
        entry.ruleReferenze = displayRules;
        // TODO könnte 1715 lösen ggf values ändern:
        // entry.values = true; ???
      } else {
        const obj = this.state[selectedContainer];
        entry = obj.find((o) => o.uniqueId === uniqueId);
        // entry.activeRule = false;
      }
      if (display) {
        const obj = this.state[selectedContainer];
        entry = obj.find((o) => o.uniqueId === uniqueId);
        entry.display = this.state.arrDisplayById[uniqueId];
        if (entry.display === 'FS') {
          entry.labelStructure.contentMap.KEY = true;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = false;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = false;
          entry.labelStructure.contentMap.FEDERATION_KEY = false;
        } else if (entry.display === 'KS') {
          entry.labelStructure.contentMap.KEY = false;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = false;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = true;
          entry.labelStructure.contentMap.FEDERATION_KEY = false;
        } else if (entry.display === 'KN') {
          entry.labelStructure.contentMap.KEY = false;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = true;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = false;
          entry.labelStructure.contentMap.FEDERATION_KEY = false;
        } else if (entry.display === 'FSKN') {
          entry.labelStructure.contentMap.KEY = true;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = true;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = false;
          entry.labelStructure.contentMap.FEDERATION_KEY = false;
        } else if (entry.display === 'KSKN') {
          entry.labelStructure.contentMap.KEY = false;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = true;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = true;
          entry.labelStructure.contentMap.FEDERATION_KEY = false;
        } else if (entry.display === 'FSKS') {
          entry.labelStructure.contentMap.KEY = true;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = false;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = true;
          entry.labelStructure.contentMap.FEDERATION_KEY = false;
        } else if (entry.display === 'VS') {
          entry.labelStructure.contentMap.FEDERATION_KEY = true;
          entry.labelStructure.contentMap.KEY = false;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = false;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = false;
        } else if (entry.display === 'VSKN') {
          entry.labelStructure.contentMap.FEDERATION_KEY = true;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = true;
          entry.labelStructure.contentMap.KEY = false;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = false;
        } else if (entry.display === 'FSVS') {
          entry.labelStructure.contentMap.FEDERATION_KEY = true;
          entry.labelStructure.contentMap.SHORT_DESCRIPTION = false;
          entry.labelStructure.contentMap.KEY = true;
          entry.labelStructure.contentMap.CLASSIFICATION_KEY = false;
        }
      }
      if (sumUp) {
        const obj = this.state[selectedContainer];
        entry = obj.find((o) => o.uniqueId === uniqueId);
        // Insgesamt
        if (sumUp.indexOf('i') > -1) {
          if (sumUp.indexOf('o') > -1) {
            entry.firstSumTotal = true;
            entry.lastSumTotal = false;
          } else {
            entry.firstSumTotal = false;
            entry.lastSumTotal = true;
          }
        } else {
          entry.firstSumTotal = false;
          entry.lastSumTotal = false;
        }
        // Zusammen
        if (sumUp.indexOf('z') > -1) {
          entry.sumTogether = true;
        } else {
          entry.sumTogether = false;
        }
      }
      if (sorting) {
        const obj = this.state[selectedContainer];
        let entry = obj.find((o) => o.uniqueId === uniqueId);
        const sortDirection = this.state.arrSortingById[uniqueId];
        if (sortDirection === 'FS') {
          entry.labelStructure.sortCriterion = 'KEY';
        } else if (sortDirection === 'KN') {
          entry.labelStructure.sortCriterion = 'DESCRIPTION'; // Enum KTX ist das gleiche
        } else if (sortDirection === 'KS') {
          entry.labelStructure.sortCriterion = 'CLASSIFICATION_KEY'; // 2166, war CATEGORY; classification key
        }
      }
      if (uniqueId in this.state.arrDirectionById) {
        const obj = this.state[selectedContainer];
        const entry = obj.find((o) => o.uniqueId === uniqueId);
        entry.labelStructure.sortDirection = this.state.arrDirectionById[uniqueId] === 'up' ? 'ASC' : 'DESC';
      }
      this.makeNestedList(this.state.selectedContainer, this.state[this.state.selectedContainer]);
      //this.updateView();
    }
    const filteredState = this.state.filtered;
    if (filteredState) {
      if (filteredState.constructor !== Array) {
        const arrFiltered = [this.state.filtered];
        this.setState({ filtered: arrFiltered });
      }
    }
    this.updateView();
    // console.log('FILTER#99', this.state[selectedContainer]);
    // cleanup
    this.setState({
      // [selectedContainer]: this.state[selectedContainer], // test
      displayRules: '',
      data_html: '',
      display: '',
      sumUp: '',
      sorting: '',
      direction: '',
      hideRetrievalButton: false,
    });
  }

  setValuesOnHideOld() {
    // console.log('Set#0');
    const {
      selectedContainer, direction, display, sumUp, sorting, selectedId, displayRules,
      arrCalcUpById, arrBMMById, calcModeOn,
    } = this.state;
    const uniqueId = selectedId;
    let { filtered } = this.state;
    // console.log('Set#0', filtered);
    // console.log('Set#2', this.state.arrFiltersById, uniqueId);
    if (filtered !== this.state.arrFiltersById[uniqueId]) {
      filtered = this.state.arrFiltersById[uniqueId];
    }
    // console.log('Set#3', filtered);
    if (filtered || display || sumUp || sorting || direction || displayRules) {
      if (filtered) {
        if (filtered.constructor.name !== 'Array') filtered = [filtered]; // selection from radio buttons cast to an array
      } else {
        filtered = 'default';
      }
      const obj = this.state[selectedContainer];
      const strSel = JSON.stringify(this.state[selectedContainer]);
      if (filtered && (filtered !== 'default')) {
        if (strSel.indexOf(uniqueId) > -1) {
          const preparedFilter = filtered.map((entry) => entry.name);
          this.traverse(obj, uniqueId, preparedFilter); // traverse over each element in the array
        }
      }
      // let entry;
      if (uniqueId in this.state.arrDirectionById) {
        const obj = this.state[selectedContainer];
        const entry = obj.find((o) => o.uniqueId === uniqueId);
        entry.labelStructure.sortDirection = this.state.arrDirectionById[uniqueId] === 'up' ? 'ASC' : 'DESC';
      }
      this.makeNestedList(this.state.selectedContainer, this.state[this.state.selectedContainer]);
      this.updateView();
    }
    const filteredState = this.state.filtered;
    if (filteredState) {
      if (filteredState.constructor !== Array) {
        const arrFiltered = [this.state.filtered];
        this.setState({ filtered: arrFiltered });
      }
    }

    // console.log('THEID#', selectedId);
    // cleanup
    this.setState({
      displayRules: '',
      data_html: '',
      display: '',
      sumUp: '',
      sorting: '',
      direction: '',
      hideRetrievalButton: false,
    });
  }

  setDisplay(e) {
    const { selectedId, arrDisplayById } = this.state;
    arrDisplayById[selectedId] = e.value;
    this.setState({
      arrDisplayById,
      display: e.value,
    });
  }

  setSorting(e) {
    const { selectedId, arrSortingById } = this.state;
    arrSortingById[selectedId] = e.value;
    // console.log('SORT#', arrSortingById[selectedId]);
    this.setState({
      arrSortingById,
      sorting: e.value,
    });
  }

  setDirection() {
    const { selectedId, arrDirectionById } = this.state;
    let currentDirection = arrDirectionById[selectedId];
    if (!currentDirection) currentDirection = 'up';
    if (currentDirection === 'up') {
      currentDirection = 'down';
    } else {
      currentDirection = 'up';
    }
    arrDirectionById[selectedId] = currentDirection;
    this.setState({
      arrDirectionById,
      direction: selectedId,
    });
  }

  hasTableLoaded() {
    const { data_html } = this.state;
    let returnValue = false;
    if (data_html) {
      returnValue = true;
    }
    return returnValue;
  }

  render() {
    const {
      visibleWait,
      allNodes,
      tableRendered,
      data_html,
      exportTableVisible,
      globalFilter,
      layoutStage,
      filter,
      headings,
      zeilen,
      spalte1,
      layout,
      itemInList,
      auspraegungenMap,
      selectedId,
      canSumUp,
      isTimeIdentifying,
      isTimeClassifying,
      isValue,
      selectionMode,
      selectedContainer,
      hasSecrets,
      col_graph,
      val_graph,
      title_graph,
      row_graph,
      test,
    } = this.state;
    console.log('ALLNODES#', allNodes);
    const role = sessionStorage.getItem('role');
    const userGroup = sessionStorage.getItem('group');
    const isMinistry = (userGroup.indexOf('Ministerium') !== -1);
    // console.log('VALUE#0', data_html);
    console.log('VALUE#1', tableRendered, auspraegungenMap);
    const internalSelectedValue = ((role === 'INTERNAL_USER' || isMinistry) && hasSecrets === true);
    const hideExportButton = !this.hasTableLoaded() || internalSelectedValue;
    const menuItems = [
      {
        label: 'Werteabruf',
        icon: 'pi pi-md-check',
        command: async () => await this.renderTable(),
      },
      {
        label: 'Tabelle exportieren',
        icon: 'pi pi-md-file-download',
        disabled: hideExportButton,
        command: () => { this.showExportTable(); },
      },
      {
        label: 'Zurück',
        icon: 'pi pi-md-chevron-left',
        command: () => { this.goBack(); },
      },
      {
        icon: 'pi pi-md-zoom-out-map',
        command: () => { maximizeTable(true); },
      },
    ];
    const key = window.location.href.split('&')[1];
    const showList = auspraegungenMap[itemInList];
    let arrFiltersById = this.state.arrFiltersById[selectedId];
    // console.log('ARRAY#', this.state.arrFiltersById, selectedId);
    if (!arrFiltersById) arrFiltersById = showList;
    if (showList && isTimeIdentifying) {
      showList.sort((a, b) => b.inhalt - a.inhalt);
    }
    const showRuleList = this.displayRulesEmpty; // .concat(rulesMap[itemInList]);
    let arrDisplayById = '';

    let hasClassificationKey = false;
    if (auspraegungenMap[itemInList]) {
      if (auspraegungenMap[itemInList][0]) {
        if (auspraegungenMap[itemInList][0].classificationKey !== null) {
          hasClassificationKey = true;
        }
      }
    }

    // Sortierung der Ausprägungen
    let { sorting } = this;
    if (!hasClassificationKey) {
      sorting = sorting.slice(0, 2);
    }
    let arrSortingById = this.state.arrSortingById[selectedId];
    if (!arrSortingById) arrSortingById = 'FS';

    // Sortierrichtung der Ausprägung Icon und Popup
    let arrDirectionById = this.state.arrDirectionById[selectedId];
    if (!arrDirectionById) arrDirectionById = 'up';
    let directionIcon = 'pi-md-expand-less';
    let directionTitle = 'aufsteigend';
    if (arrDirectionById === 'down') {
      directionIcon = 'pi-md-expand-more';
      directionTitle = 'absteigend';
    }

    // Filter
    let { display } = this;
    if (!hasClassificationKey) {
      display = display.slice(0, 3);
    }
    if (this.state.arrDisplayById[selectedId]) arrDisplayById = 'KN';
    arrDisplayById = this.state.arrDisplayById[selectedId];
    if (!arrDisplayById) arrDisplayById = 'KN';

    const arrSumUpById = this.state.arrSumUpById[selectedId];
    const header = (
      <div className="table-header">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText value={globalFilter} type="search" onChange={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Ausprägungen filtern" />
        </span>
      </div>
    );

    layout[0] = (
      <div>
        <h2>{KeyFigureNames[key]}</h2>
        <div className="p-col-2 p-md-12">
          <DataTable
            selectionMode="single"
            // onSelectionChange={(e) => this.viewItemProperties(e.value)}
            value={allNodes}
            // rows={10}
            totalRecords={allNodes.length}
          >
            <Column field="name" header="Name" />
            <Column field="caption" header="Beschriftung" />
            <Column
              header="Aktionen"
              body={this.actionTemplate}
              style={{ width: '7em' }}
            />
          </DataTable>
        </div>
      </div>
    );
    layout[1] = (
      <div>
        <table border="0">
          <thead>
            <tr>
              <td id="td_merkmale" valign="top" rowSpan="3" />
              <td id="td_menu" valign="top" colSpan="3">
                <Menubar model={menuItems} style={{ maxWidth: '40em' }} />
              </td>
            </tr>
            <tr>
              <td id="td_filterzeilen" width="10%" valign="top" rowSpan="2">
                <div style={{ width: '240px' }}>
                  <Container
                    id={6}
                    list={filter}
                    containerName="filter"
                    unmoveable
                    removeCard={this.removeCard.bind(this)}
                    moveCard={this.removeCard.bind(this)}
                    showOverlay={this.showOverlay.bind(this)}
                    makeNestedList={this.makeNestedList.bind(this)}
                    header="Vorbedingungen/Filter"
                    popup=""
                  />
                </div>
                <div style={{ width: '240px' }}>
                  <HeadingsContainer
                    id={7}
                    list={headings}
                    containerName="headings"
                    unmoveable
                    removeCard={this.removeCard.bind(this)}
                    moveCard={this.removeCard.bind(this)}
                    showOverlay={this.showOverlay.bind(this)}
                    makeNestedList={this.makeNestedList.bind(this)}
                    header="Zwischenüberschrift"
                    popup=""
                  />
                </div>
                <div style={{ width: '240px' }}>
                  <Container
                    id={8}
                    list={zeilen}
                    containerName="zeilen"
                    unmoveable
                    removeCard={this.removeCard.bind(this)}
                    moveCard={this.removeCard.bind(this)}
                    showOverlay={this.showOverlay.bind(this)}
                    makeNestedList={this.makeNestedList.bind(this)}
                    header="Zeilendefinition 1"
                    popup=""
                  />
                </div>
                {this.renderRowContainers()}
              </td>
              <td id="td_spalten" valign="top" colSpan="2" style={{ display: 'flex' }}>
                <div style={{ width: '240px' }}>
                  <ColContainer
                    id="999"
                    list={spalte1}
                    containerName="spalte1"
                    unmoveable
                    removeCard={this.removeCard.bind(this)}
                    moveCard={this.removeCard.bind(this)}
                    showOverlay={this.showOverlay.bind(this)}
                    makeNestedList={this.makeNestedList.bind(this)}
                    header="Spaltendefinition 1"
                  />
                </div>
                {this.renderColContainers()}
              </td>
            </tr>
            <tr>
              <td id="td_tabelle" height="600px" width="20px" valign="top" colSpan="2">
                <div id="pivotTableDiv">
                  <div width="100%" id="implodeExpand" style={{ textAlign: 'right', visibility: 'hidden' }}>
                    <Button icon="pi-md-crop-free" onClick={() => maximizeTable(false)} />
                  </div>
                  <div id="results">
                    <DestatisTableRenderer2
                      test={test}
                      isKeyFigure="true"
                      {...tableRendered}
                      data_html={data_html}
                      disableCache="true" // kann ggf. wieder entfernt werden
                    />
                  </div>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td id="td_unten" width="100%" valign="top" colSpan="4" />
            </tr>
          </tbody>
        </table>
      </div>
    );
    const sumUpSelectItems = [
      { label: '▲', value: 'o' },
      { label: 'Insgesamt', value: 'i' },
      { label: 'Zusammen', value: 'z' },
    ];
    const sumUpDivClassName = 'p-col-11';
    let sumUpButtons = (
      <>
        <div className="p-col-1" style={{ textAlign: 'center', fontSize: 'large', color: '#898989' }} title="Summe">
          ∑
        </div>
        <div className={sumUpDivClassName}>
          <SelectButton
            disabled={!canSumUp}
            value={arrSumUpById}
            options={sumUpSelectItems}
            onChange={(e) => this.setSumUp(e)}
            multiple
          />
        </div>
      </>
    );
    if (isTimeIdentifying || isTimeClassifying || isValue) sumUpButtons = undefined;
    // const showRuleList = {};
    const showRuleSelection = '';
    const isTime = isTimeIdentifying || isTimeClassifying;
    let showRules;
    if (showRuleList.length === 2 && !showRuleList[1]) {
      showRules = showRuleList[1]; // empty default has 2 values && second is undefined
    } else {
      showRules = true;
    }
    const showSorting = !(selectedContainer === 'filter' && isTime);
    const showDisplaySelection = (!isTime);
    return (
      <DndProvider backend={HTML5Backend}>
        <div className="p-col-12 p-lg-12">
          {/* This Dialogue is for waiting */}
          <Dialog header="Lade Daten..." closable={false} closeOnEscape={false} visible={visibleWait} modal onHide={() => this.setState({ visibleWait: false })}>
            <div style={{ textAlign: 'center' }}><ProgressSpinner /></div>
          </Dialog>
          {/* This Dialogue is for exporting tables */}
          <ExportTableDialog
            exportTableVisible={exportTableVisible}
            onHideExportTable={this.onHideExportTable.bind(this)}
            exportTable={this.exportTable.bind(this)}
          />
          {/* Popup for sort and filter selection */}
          <OverlayPanel
            ref={(el) => { this.op = el; }}
            onHide={(e) => this.setValuesOnHide(e)}
          >
            <div className="p-grid" style={{ width: '300px' }}>
              {sumUpButtons}
              {showSorting
                ? (
                  <>
                    <div className="p-col-1" title="Sortierung">
                      <i className="pi pi-md-sort" />
                    </div>
                    <div className="p-col-1" style={{ textAlign: 'center', fontSize: 'large', color: '#898989' }} />
                    <div className="p-col-8">
                      <DropdownLabeled
                        disabled={selectionMode === 'none' || isTime}
                        id="line"
                        label="Sortierung der Ausprägungen"
                        name="line"
                        options={sorting}
                        value={arrSortingById}
                        onChange={(e) => this.setSorting(e)}
                        autoWidth={false}
                        tooltipOptions={{ event: 'focus' }}
                      />
                    </div>
                    <div className="p-col-2">
                      <Button
                        icon={directionIcon}
                        onClick={() => this.setDirection()}
                        disabled={selectionMode === 'none'}
                        title={directionTitle}
                      />
                    </div>
                  </>
                ) : undefined}
              {showDisplaySelection
                ? (
                  <>
                    <div className="p-col-12">
                      <DropdownLabeled
                        disabled={selectionMode === 'none'}
                        style={{ width: '260px' }}
                        id="line"
                        label="Anzeige der Ausprägungen"
                        name="line"
                        options={display}
                        value={arrDisplayById}
                        onChange={(e) => this.setDisplay(e)}
                        autoWidth={false}
                        tooltipOptions={{ event: 'focus' }}
                      />
                    </div>
                  </>
                ) : undefined}
              <div>
                {showRules === true && showRuleSelection
                  ? (
                    <div className="p-col-12" />
                  ) : undefined}
              </div>
              <div className="p-col-12">
                {selectionMode === 'none'
                  ? undefined
                  : (
                    <div>
                      <DataTable
                        id="dataTable"
                        globalFilter={globalFilter}
                        emptyMessage="keine Ausprägungen gefunden"
                        header={header}
                        value={showList}
                        selection={arrFiltersById}
                        onSelectionChange={(e) => this.setValues(e)}
                        dataKey="id"
                        scrollable
                        scrollHeight="205px"
                      >
                        <Column
                          selectionMode={selectionMode}
                          headerStyle={{ width: '3em' }}
                        />
                        <Column
                          field="inhalt"
                          header={selectionMode === 'multiple' ? 'alle Ausprägungen auswählen' : 'Ausprägungen'}
                        />
                      </DataTable>
                    </div>
                  )}
              </div>

            </div>
          </OverlayPanel>
          {/* Pop-up hints */}
          <Growl ref={(el) => { this.growl = el; }} />
          {/* Layout */}
          {layout[layoutStage]}
        </div>
      </DndProvider>
    );
  }
}
